// Client-side store for the request-scoped session token issued by
// `requestGetAuth` after a successful validationCode verification.
// Mirrors `portalSession` but lives in a separate slot. The two can
// coexist when a patient opens an emailed request on a device that is
// already signed in to the portal, so request calls must explicitly
// prefer this token. Keeping them separate also prevents a patient
// logout from clobbering an in-progress request session and vice versa.

const TOKEN_KEY = 'healthcom-schedule.requestSession.token';
const REQUEST_ID_KEY = 'healthcom-schedule.requestSession.requestId';
const EXPIRES_KEY = 'healthcom-schedule.requestSession.expiresAt';

export const requestSession = {
  getToken(): string | null {
    try {
      return sessionStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },

  setToken(token: string, requestId: string, expiresAt?: string) {
    try {
      sessionStorage.setItem(TOKEN_KEY, token);
      sessionStorage.setItem(REQUEST_ID_KEY, requestId);
      if (expiresAt) sessionStorage.setItem(EXPIRES_KEY, expiresAt);
    } catch {
      /* storage blocked */
    }
  },

  getRequestId(): string | null {
    try {
      return sessionStorage.getItem(REQUEST_ID_KEY);
    } catch {
      return null;
    }
  },

  clear() {
    try {
      sessionStorage.removeItem(TOKEN_KEY);
      sessionStorage.removeItem(REQUEST_ID_KEY);
      sessionStorage.removeItem(EXPIRES_KEY);
    } catch {
      /* ignore */
    }
  },

  isLikelyValid(): boolean {
    const token = this.getToken();

    if (!token) return false;

    let expiresAt: string | null = null;

    try {
      expiresAt = sessionStorage.getItem(EXPIRES_KEY);
    } catch {
      return true;
    }

    if (!expiresAt) return true;

    const expiresAtMs = Date.parse(expiresAt);

    return Number.isFinite(expiresAtMs) && expiresAtMs > Date.now();
  },
};
